import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {environment} from "@galec/environments/environment";
import {LangService} from "@galec/services/global/lang.service";

@Component({
    selector: 'galec-maintenance',
    templateUrl: './maintenance.component.html',
    styleUrls: ['./maintenance.component.scss']
})
export class MaintenanceComponent implements OnInit {

    constructor(
        private router: Router,
        private readonly langService: LangService,
    ) {
    }

    ngOnInit(): void {
        if (!environment.maintenance) {
            this.langService.navigate('/app/home');
        }
    }
}

